/*
 * @Author: qh_feng
 * @Date: 2022-03-17 17:22:49
 * @LastEditTime: 2023-06-27 10:17:26
 * @LastEditors: your name
 * @Description:
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:  申报管理-  API
 */
export default {
  //企业信息管理
  POST_hyEnterpriseIndex: '/dqi-hymanage/hyEnterprise/index',
  POST_hyEnterpriseAdd: '/dqi-hymanage/hyEnterprise/add',
  POST_hyEnterpriseUpdate: '/dqi-hymanage/hyEnterprise/update',
  POST_hyEnterpriseUploadImg: '/dqi-hymanage/hyEnterprise/upload',
  POST_hyEnterpriseVerifyEnterprise: '/dqi-hymanage/hyEnterprise/verifyEnterprise',
  GET_hyEnterpriseDelete: '/dqi-hymanage/hyEnterprise/delete/',
  GET_hyEnterpriseFind: '/dqi-hymanage/hyEnterprise/find/',
  POST_hyEnterpriseByRole: '/dqi-hymanage/hyEnterprise/getEnterpriseByRole',
  //人员信息申报
  POST_hyPersonAdd: '/dqi-hymanage/hyPerson/add',
  POST_hyPersonIndex: '/dqi-hymanage/hyPerson/index',
  POST_hyPersonUpdate: '/dqi-hymanage/hyPerson/update',
  POST_hyPersonUploadImg: '/dqi-hymanage/hyPerson/upload',
  POST_hyPersonVerifyPerson: '/dqi-hymanage/hyPerson/verifyPerson',
  GET_hyPersonDelete: '/dqi-hymanage/hyPerson/delete/',
  GET_hyPersonFind: '/dqi-hymanage/hyPerson/find/',
  //车辆信息申报
  POST_hyCarAdd: '/dqi-hymanage/hyCar/add',
  POST_hyCarIndex: '/dqi-hymanage/hyCar/index',
  POST_hyCarUpdate: '/dqi-hymanage/hyCar/update',
  POST_hyCarUploadImg: '/dqi-hymanage/hyCar/upload',
  POST_hyCarVerifyEnterprise: '/dqi-hymanage/hyCar/verifyEnterprise',
  GET_hyCarDelete: '/dqi-hymanage/hyCar/delete/',
  GET_hyCarFind: '/dqi-hymanage/hyCar/find/',

  //小程序人员信息申报
  POST_hyPersonDeclareAdd: '/dqi-hymanage/hyPersonDeclare/add',
  POST_hyPersonDeclareIndex: '/dqi-hymanage/hyPersonDeclare/getAllPerson',
  GET_hyPersonDeclareFind:'/dqi-hymanage/hyPersonDeclare/find/',
  GET_hyPersonDeclareDelete: '/dqi-hymanage/hyPersonDeclare/delete/',
  POST_hyPersonDeclareUploadImg: '/dqi-hymanage/hyPersonDeclare/upload',
  POST_hyPersonDeclareVerify: '/dqi-hymanage/hyPersonDeclare/verifyPerson',
  POST_hyPersonDeclareCheck: '/dqi-hymanage/hyPersonDeclare/getAllPersonCheck',
  POST_hyPersonDeclareBatchCheck: '/dqi-hymanage/hyPersonDeclare/batch/verifyPerson',
  //小程序车辆信息申报
  POST_hyCarDeclareIndex: '/dqi-hymanage/hyCarDeclare/getAllCar',
  POST_hyCarDeclareAdd: '/dqi-hymanage/hyCarDeclare/add',
  GET_hyCarDeclareFind:'/dqi-hymanage/hyCarDeclare/find/',
  GET_hyCarDeclareDelete: '/dqi-hymanage/hyCarDeclare/delete/',
  POST_hyCarDeclareUploadImg: '/dqi-hymanage/hyCarDeclare/upload',
  POST_hyCarDeclareVerify: '/dqi-hymanage/hyCarDeclare/verifyCar',
  POST_hyCarDeclareCheck: '/dqi-hymanage/hyCarDeclare/getAllCarCheck',
  POST_hyCarDeclareWebCheck: '/dqi-hymanage/hyCarDeclare/web/getAllCarCheck',
  POST_hyCarDeclareBatchCheck: '/dqi-hymanage/hyCarDeclare/batch/verifyCar',
  POST_getReExpire: '/dqi-hymanage/hyCarDeclare/getReExpire',

  //车辆审批权限
  GET_ApproveList:'/dqi-hymanage/hyCarDeclare/getApproveList/',
  GET_getLastId:'/dqi-hymanage/hyCarDeclare/getLastId/',
  POST_updateApprove:'/dqi-hymanage/hyCarDeclare/updateApprove/',
  POST_addApprove:'/dqi-hymanage/hyCarDeclare/addApprove/',
  POST_delay: '/dqi-hymanage/hyCarDeclare/delay',
  POST_batchDelay: '/dqi-hymanage/hyCarDeclare/batch/delay',
}



// WEBPACK FOOTER //
// ./src/http/apiModules/sbgl.js